import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import swal from 'sweetalert2';
import swal1 from 'sweetalert2';
import { Router, ActivatedRoute } from '@angular/router';
import { UserService } from '../../../../../shared/user.service';
import { ErrorHandler } from '../../../../../shared/ErrorHandler';
import { Search } from '../../../../../shared/user.model';
import { TitleCasePipe } from '@angular/common';


@Component({
  selector: 'app-income-tax-form',
  templateUrl: './income-tax-form.component.html',
  styleUrls: ['./income-tax-form.component.css']
})
export class IncomeTaxFormComponent implements OnInit {

  constructor(private userService: UserService, private router: Router, private route: ActivatedRoute, private errorHandler: ErrorHandler,
    private titlecasePipe:TitleCasePipe) { }

  ngOnInit() {
   
  }

}



// WEBPACK FOOTER //
// ./src/app/hrms/payroll/organisation-profile/income-tax/income-tax-form/income-tax-form.component.ts